module.exports = __webpack_public_path__ + "static/media/login-image.55cef371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-image.jpg
// module id = 537
// module chunks = 0